import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
//SERVICIOS
import { TipoComprobanteService } from '../../../services/tipo-comprobante.service';
import { ComprobanteService } from '../../../services/comprobante.service';
import { SessionService } from '../../../services/session.service';
import { BodegaService } from '../../../services/bodega.service';
import { ClienteService } from '../../../services/cliente.service';
import { FormaPagoService } from '../../../services/forma-pago.service';
import { CajaService } from '../../../services/caja.service';
import { VentaService } from '../../../services/venta.service';
import { ParametroService } from '../../../services/parametro.service';
import { SucursalService } from '../../../services/sucursal.service';
import { ProductoService } from '../../../services/producto.service';
import { CbtContadorService } from '../../../services/cbt-contador.service';
import { AsignacionCajaService } from '../../../services/asignacion-caja.service';
import { ProformaService } from '../../../services/proforma.service';

//MODELS
import { TipoDocumento } from '../../../models/tipo-documento';
import { Venta } from '../../../models/venta';
import { Caja } from '../../../models/caja';
import { VentaDetalle } from '../../../models/venta_detalle';
import { Cliente } from '../../../models/cliente';
import { Bodega } from '../../../models/bodega';
import { Sucursal } from '../../../models/sucursal';
import { Cheque } from '../../../models/cheque';
import { Tarjeta } from '../../../models/tarjeta';
import { Cobro } from '../../../models/cobro';
import { CobroDetalle } from '../../../models/cobro_detalle';

//OTROS
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';
import * as moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import * as numeral from 'numeral';

//MODALES
import { ClienteModalComponent } from '../../modals/cliente-modal/cliente-modal.component';
import { AperturaCajaModalComponent } from '../../modals/apertura-caja-modal/apertura-caja-modal.component';
import { ProductoPrecioModalComponent } from '../../modals/producto-precio-modal/producto-precio-modal.component';
import { ConfirmacionAnulacionModalComponent } from '../../../components/modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { CierreCajaModalComponent } from '../../../components/modals/cierre-caja-modal/cierre-caja-modal.component';
import { ServicioModalComponent } from '../../modals/servicio-modal/servicio-modal.component';
import { ProformaModalComponent } from '../../modals/proforma-modal/proforma-modal.component';
import { Proforma } from '../../../models/proforma';
import { PreciosModalComponent } from '../../../components/modals/precios-modal/precios-modal.component';
import { PrecioAdicional } from '../../../models/precio_adicional';
import { Producto } from '../../../models/producto';
import { ConfigService } from '../../../config/config-service';
import { ImageModalComponent } from '../../modals/image-modal/image-modal.component';
import { DatosPagosComponent } from '../../../controls/datos-pago/datos-pago.component';
import { UtilsService } from '../../../services/utils.service';
import { ReporteModalComponent } from '../../modals/reporte-modal/reporte-modal.component';
import { AmortizacionDetalle } from '../../../models/amortizacion_detalle';
import { Amortizacion } from '../../../models/amortizacion';

import { environment } from '../../../../environments/environment';
import { LectorBarraModalComponent } from '../../modals/lector-barra-modal/lector-barra-modal.component';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';
import { Transferencia } from '../../../models/transferencia';

@Component({
  selector: 'app-punto-venta-add',
  templateUrl: './punto-venta-add.component.html',
  styleUrls: ['./punto-venta-add.component.css'],
  providers: [
    TipoComprobanteService,
    ComprobanteService,
    SessionService,
    BodegaService,
    ClienteService,
    FormaPagoService,
    VentaService,
    CajaService,
	ParametroService,
    SucursalService,
    AsignacionCajaService,
    ProformaService,
    ProductoService,
    ImpuestoPorcentajeService
]
})
export class PuntoVentaAddComponent implements OnInit {
    public venta: Venta;
    public validDateFecha: Boolean;
    public vl: Validation;
    public fecha_emision;
    public cliente: Cliente;
    public is_numero_manual: boolean;
    public numero_documento: String;
    public Mod_Inventario: string;
    public Mod_FactElec: string;
    public ventasDetalle: Array<VentaDetalle>;
    public total_pago: number;
    public IVA: number;
    public IVA_PARAM: number;
    public Identif: string;
    public tipos: Array<TipoDocumento>;
    public bodegas: Array<Bodega>;
    public bodegas_selected: Array<any>;
    public isPrinted: boolean;
    public ventaIdPrinted: String;
    public loading: boolean;
    public msgSweet: SweetMessage;
    public cambio: number;
    public bsModalRef: BsModalRef;
    public sucursal: Sucursal;
    public caja: Caja;
    public cheques: Array<Cheque>;
    public tarjetas: Array<Tarjeta>;
    public valorefectivo: number;
    public cobro: Cobro;
    public asignacion_id: number;
    public proforma: Proforma;
    public detalle: String;
    private venta_detalle: VentaDetalle;
    public is_precios: boolean;
    public PreciosAdd: PrecioAdicional;
    public correos: Array<any>;
    public is_precio_unitario_editable: boolean;
    public product_barcode: Producto;
    public notfound_barcode: any;
    public codigo_producto: String;
    public ruta_imagen: String;
    public config: ConfigService;
    public numero_decimales: number;
    public format_decimal: String;
    @ViewChild(DatosPagosComponent) datosPagos: DatosPagosComponent;
    public amortizacion: Amortizacion;
    public calculo_decimales: number;
    public uploadfile_api: String;
    public transferencias: Array<Transferencia>;
    public is_venta:boolean;
    public iva_id: number;
	public iva_porcentaje : any;
	public parametros: Array<any>;

  constructor(
	public ss: SessionService,
	private parametroService: ParametroService,
	public tipoComprobanteService: TipoComprobanteService,
	public bodegaService: BodegaService,
	public comprobanteService: ComprobanteService,
	public clienteService: ClienteService,
	private modalService: BsModalService,
	public cajaService: CajaService,
	public sucursalService: SucursalService,
	public ventaService: VentaService,
    public cbtContadorService: CbtContadorService,
    public asignacionService: AsignacionCajaService,
    public proformaService: ProformaService,
    public productoService: ProductoService,
    public utils: UtilsService,
    public impuestoPorcentajeService: ImpuestoPorcentajeService

  ) {
		this.venta = new Venta();
		this.validDateFecha = false;
		this.vl = new Validation();
		this.fecha_emision = moment(this.fecha_emision);
		this.cliente = new Cliente();
		this.is_numero_manual = false;
		this.numero_documento = "";
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.Mod_Inventario = this.ss.getData("mod_inventario");
		this.ventasDetalle = [];
		this.total_pago = 0;
		this.IVA = 0;
		this.IVA_PARAM = 0;
		this.Identif = "";
		this.tipos = [];
		this.bodegas = [];
		this.bodegas_selected = [];
		this.ventaIdPrinted = "";
		this.isPrinted = false;
		this.loading = false;
		this.msgSweet = new SweetMessage();
		this.cambio = 0;
		this.bsModalRef = new BsModalRef();
		this.sucursal = new Sucursal();
		this.caja = new Caja();
		this.cheques = [];
		this.tarjetas = [];
		this.valorefectivo = 0;
        this.cobro = new Cobro();
        this.asignacion_id = 0;
        this.proforma = new Proforma();
        this.detalle = "";
        this.venta_detalle = new VentaDetalle();
        this.is_precios = false;
        this.PreciosAdd = new PrecioAdicional();
        this.correos = [];
        this.is_precio_unitario_editable = false;
        this.product_barcode = null;
        this.notfound_barcode = null;
        this.codigo_producto = "";
        this.ruta_imagen = "";
        this.config = new ConfigService();
        this.calculo_decimales = 2;
        this.numero_decimales = 2;
        this.format_decimal = "0,0.00";
        this.amortizacion = new Amortizacion();
        this.uploadfile_api = environment.uploadfile_api;
        this.iva_id = 0;
		this.parametros = [];
		this.iva_porcentaje = 0;
        this.transferencias = [];
        this.is_venta = false;

    }

    ngOnInit() {
        let p1 = this.onAperturaCaja();
        let p2 = this.getTiposComprobante();
        let p3 = this.getBodegas();
        let p4 = this.getDataSucursal();
        let p5 = this.getConsumidorFinal();
        let p6 = this.getPreciosAdicionales();
        let p7 = this.getBodegaBySucursal();
        let p8 = this.getParametroIva();
        let p9 = this.getIVA(129);

        // this.getParametros();

        this.loading = true;
        this.is_venta = true;

        Promise.all([p1,p2,p3,p4,p5,p6,p7,p8,p9]).then(
            res => this.loading = false,
            err => this.loading = false
        );
    }
    
    getParametros(){
        // this.IVA = parseFloat(this.ss.getData("IVA"));
        // this.IVA_PARAM = parseFloat(this.ss.getData("IVA_PARAM"));
        this.is_precios = this.ss.getData("precios_adicionales") == "true";
        this.is_numero_manual = this.ss.getData("is_numero_manual") == "true";
        this.is_precio_unitario_editable = this.ss.getData("is_precio_unitario_editable") == "true";
        this.numero_decimales = parseFloat(this.ss.getData("numero_decimales"));
        this.format_decimal = this.ss.getData("format_decimal");
    }

    getIVA(id) {
		return new Promise((resolve, reject) => {

			this.impuestoPorcentajeService.getById(id).subscribe(
				res => {
					this.iva_porcentaje = (res.porcentaje*100)/100;
                    this.IVA = parseFloat(this.iva_porcentaje) / 100;
                    this.IVA_PARAM = this.iva_porcentaje;
					this.calcularFactura();
        			this.calcularCuotasCredito();
					resolve();
				},
				err => {
					this.iva_porcentaje = 0;
                    this.IVA = 0;
                    this.IVA_PARAM= 0;
					reject(err);
				}
			);

			
		});
	}

	getParametroIva() {
		return new Promise((resolve, reject) => {
			let qs ="?impuesto_id=2&is_tarifa=1&is_vigente=1&is_comprobante=1";
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					this.parametros = res.data;
					this.iva_id = this.parametros[0].id;
					resolve();
				},
				err => {
					this.parametros = [];
					reject(err);
				}
			);

		});
	}

	onChangeIva(id) {
		this.loading = true;

		this.getIVA(id).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}


    getConsumidorFinal(){
        return new Promise((resolve, reject) => {
            this.clienteService.getById(1, '?embed=tipoidentificacion').subscribe(
                res => {
                    this.cliente = res.data;
                    if (this.cliente.correo.trim().length) {
                        this.correos = this.cliente.correo.split(',');
                    }
                    resolve();
                },
                err => {
                    this.loading = false;
                    reject(err);
                }
            );
        });
    }

    setValueCobro() {
        this.cobro.fecha_cobro = moment(this.fecha_emision).format("YYYY-MM-DD");
        this.cobro.detalle = [];
        this.cobro.saldo = this.venta.total;
        this.cobro.recibido = this.total_pago;
        this.cobro.cambio = this.cambio;
        this.cobro.empresa_id = this.ss.getData("empresa_id");
        this.cobro.sucursal_id = this.ss.getData("sucursal_id");
        this.cobro.usuario_id = this.ss.getData("usuario_id");

        if (this.valorefectivo > 0) {
            let cobro_detalle = new CobroDetalle();
            cobro_detalle.valor = this.valorefectivo;
            cobro_detalle.forma_pago_id = "1"; // EFECTIVO
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        }

        this.cheques.forEach(ch => {
            let cobro_detalle = new CobroDetalle();

            cobro_detalle.fecha_cheque = ch.fecha;
            cobro_detalle.numero_cta = ch.cuenta;
            cobro_detalle.numero_cheque = ch.numero;
            cobro_detalle.banco_id = ch.banco_id;
            cobro_detalle.observacion = ch.observacion;

            cobro_detalle.valor = ch.valor;
            cobro_detalle.forma_pago_id = ch.forma_pago_id; // CHEQUE
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        });

        this.tarjetas.forEach(tr => {
            let cobro_detalle = new CobroDetalle();

            cobro_detalle.debito_credito = tr.debito_credito;
            cobro_detalle.observacion = tr.observacion;
            cobro_detalle.tipo_tarjeta_id = tr.tipo_id;
            cobro_detalle.valor = tr.valor;
            cobro_detalle.plazo = tr.plazo;
            cobro_detalle.tiempo = tr.tiempo;
            cobro_detalle.forma_pago_id = tr.forma_pago_id; // TARJETA
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        });

        this.transferencias.forEach(tr => {
            let cobro_detalle = new CobroDetalle();

            cobro_detalle.fecha_transferencia = tr.fecha;
            cobro_detalle.numero_cta = tr.cuenta;
            cobro_detalle.numero_comprobante = tr.numero;
            cobro_detalle.banco_id = tr.banco_id;
            cobro_detalle.observacion = tr.observacion;

            cobro_detalle.valor = tr.valor;
            cobro_detalle.forma_pago_id = tr.forma_pago_id; // TRANSFERENCIA
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        });
    }

    getPreciosAdicionales() {
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let precio_adicional_id = 16;
            this.parametroService.getById(precio_adicional_id).subscribe(
                res => {
                    this.is_precios = (res.valor.toString().trim() === "SI");
                    resolve();
                },
                err => {
                    this.is_precios = false;
                    reject(err);
                }
            );
        });
    }

    /*getPrecioUnitarioEditable(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let precio_unitario_editable_id = 18;
            this.parametroService.getById(precio_unitario_editable_id).subscribe(
                res => {
                    this.is_precio_unitario_editable = (res.valor.toString().trim() === "1");
                    resolve();
                },
                err => {
                    this.is_precio_unitario_editable = false;
                    reject(err);
                }
            );
        });
    }*/

    /*getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";

                    this.datosPagos.numero_decimales = this.numero_decimales;
                    this.datosPagos.setFormat();

                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }*/////

    get formatDecimal() {
        return this.format_decimal;
    }

    setValueEntity() {
        this.venta.caja_id = this.caja.id;
        this.venta.asignacion_caja_id = this.asignacion_id.toString();
        this.venta.is_secuencial_manual = this.is_numero_manual;
        if (this.is_numero_manual) this.venta.numero_documento = this.numero_documento;
        this.venta.cliente_id = this.cliente.id;
        this.venta.cliente = this.cliente;
        this.venta.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD")
        this.venta.usuario_id = this.ss.getData('usuario_id');
        this.venta.empresa_id = this.ss.getData('empresa_id');
        this.venta.sucursal_id = this.ss.getData('sucursal_id');
        this.venta.cobros.push(this.cobro);

        this.ventasDetalle.forEach(detalle => {
            if (parseInt(this.venta.tipo_comprobante_id.toString()) === 1 || parseInt(this.venta.tipo_comprobante_id.toString()) === 4) {
                if (!detalle.graba_iva) {
                    detalle.iva = 0;
                } else {
                    detalle.iva = detalle.subtotal * this.IVA;
                }
            } else {
                detalle.iva = 0;
            }
            detalle.total = detalle.subtotal + detalle.iva;
        });

        this.venta.detalle = this.ventasDetalle;

        this.amortizacion.valor = this.saldoCuotas();
        this.amortizacion.numero_cuotas = this.amortizacion.detalle.length;
        this.amortizacion.empresa_id = this.ss.getData('empresa_id');
        this.amortizacion.usuario_id = this.ss.getData('usuario_id');
        this.venta.amortizacion = this.amortizacion;
    }

    setVentaElectronica(venta: Venta) {
        let ventaElectronica = {};
        ventaElectronica['datos'] = {};
        ventaElectronica['datos']['infoTributaria'] = {};
        ventaElectronica['datos']['infoTributaria']['ambiente'] = "";
        ventaElectronica['datos']['infoTributaria']['tipoEmision'] = 1;
        ventaElectronica['datos']['infoTributaria']['razonSocial'] = "";
        ventaElectronica['datos']['infoTributaria']['ruc'] = this.ss.getData('emp_ruc');
        ventaElectronica['datos']['infoTributaria']['claveAcceso'] = "";
        ventaElectronica['datos']['infoTributaria']['codDoc'] = "01"; //Factura
        ventaElectronica['datos']['infoTributaria']['estab'] = venta.serie;
        ventaElectronica['datos']['infoTributaria']['ptoEmi'] = venta.punto_emision;
        ventaElectronica['datos']['infoTributaria']['secuencial'] = venta.secuencial.toString().padStart(9, "0");
        ventaElectronica['datos']['infoTributaria']['dirMatriz'] = "";

        ventaElectronica['datos']['infoFactura'] = {};
        ventaElectronica['datos']['infoFactura']['fechaEmision'] = moment(venta.fecha_emision).format("DD/MM/YYYY");
        ventaElectronica['datos']['infoFactura']['tipoIdentificacionComprador'] = this.cliente.tipoidentificacion.cod_dni;
        ventaElectronica['datos']['infoFactura']['razonSocialComprador'] = this.cliente.razon_social;
        ventaElectronica['datos']['infoFactura']['identificacionComprador'] = this.cliente.dni;
        ventaElectronica['datos']['infoFactura']['totalSinImpuestos'] = (venta.subtotal_iva12 + venta.subtotal_iva0);
        ventaElectronica['datos']['infoFactura']['totalDescuento'] = venta.desct_valor;

        ventaElectronica['datos']['infoFactura']['totalConImpuestos'] = [];
        if (venta.subtotal_iva0 > 0) {
            let totalConImpuestos = {};
            totalConImpuestos['codigo'] = 2;
            totalConImpuestos['codigoPorcentaje'] = 0;
            totalConImpuestos['descuentoAdicional'] = venta.desct_valor;
            totalConImpuestos['baseImponible'] = venta.subtotal_iva0;
            totalConImpuestos['valor'] = "0.00";

            ventaElectronica['datos']['infoFactura']['totalConImpuestos'].push(totalConImpuestos);
        }

        if (venta.subtotal_iva12 > 0) {
            let totalConImpuestos = {};
            totalConImpuestos['codigo'] = 2;
            totalConImpuestos['codigoPorcentaje'] = 2;
            totalConImpuestos['descuentoAdicional'] = venta.desct_valor;
            totalConImpuestos['baseImponible'] = venta.subtotal_iva12;
            totalConImpuestos['valor'] = venta.iva;

            ventaElectronica['datos']['infoFactura']['totalConImpuestos'].push(totalConImpuestos);
        }

        ventaElectronica['datos']['infoFactura']['propina'] = "0.00";
        ventaElectronica['datos']['infoFactura']['importeTotal'] = venta.total;
        ventaElectronica['datos']['infoFactura']['moneda'] = "DOLAR";

        ventaElectronica['datos']['infoFactura']['pagos'] = [];

        if (this.venta.tipo == "CO") {
            //01 => EFECTIVO
            if (this.valorefectivo > 0) {
                let pago = {};
                pago["formaPago"] = "01";
                pago["total"] = parseFloat(this.valorefectivo.toString()) - parseFloat(this.cambio.toString());
                pago["plazo"] = "0";
                pago["unidadTiempo"] = "DIAS";
                ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
            }

            let totalChOtrosCon = 0;
            this.cheques.forEach(ch => {
                totalChOtrosCon += parseFloat(ch.valor.toString());
            });

            //20 => OTROS
            if (totalChOtrosCon > 0) {
                let pago = {};
                pago["formaPago"] = "20";
                pago["total"] = totalChOtrosCon;
                pago["plazo"] = "0";
                pago["unidadTiempo"] = "DIAS";
                ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
            }

            //16 => DEBITO; 19 => CREDITO
            this.tarjetas.forEach(tr => {
                let pago = {};
                pago["formaPago"] = (tr.debito_credito === "D" ? "16" : "19");
                pago["total"] = tr.valor;
                pago["plazo"] = tr.plazo;
                pago["unidadTiempo"] = tr.tiempo.toUpperCase();
                ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
            });
        } else {
            //20 => OTROS
            let pago = {};
            pago["formaPago"] = "20";
            pago["total"] = parseFloat(venta.total.toString()) - parseFloat(this.cambio.toString());
            pago["plazo"] = "0";
            pago["unidadTiempo"] = "DIAS";
            ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
        }

        let totalTrOtrosCon = 0;
        this.transferencias.forEach(tr => {
            totalTrOtrosCon += parseFloat(tr.valor.toString());
        });

        if( totalTrOtrosCon > 0 ){
            let pago = {};
            pago["formaPago"] = "20";
            //pago["total"] = (Math.round(totalChOtrosCon * 100) / 100);
            pago["total"] = this.utils.redondear(totalTrOtrosCon, this.calculo_decimales);
            pago["plazo"] = "0";
            pago["unidadTiempo"] = "DIAS";
            ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
        }

        ventaElectronica['datos']['detalles'] = [];
        venta.detalle.forEach((item) => {
            let detalle = {};
            let detalle_item = item.detalle.toString().replace("\n", ", ");

            detalle['codigoPrincipal'] = (item.codigo).replace('/', '-');
            detalle['codigoAuxiliar'] = (item.codigo).replace('/', '-');
            detalle['descripcion'] = (item.producto + (item.detalle.length > 0 ? " - " + detalle_item : "")).replace('/', '-');
            detalle['cantidad'] = item.cantidad;
            detalle['precioUnitario'] = item.precio_unitario;
            detalle['descuento'] = item.desc_valor;
            detalle['precioTotalSinImpuesto'] = item.subtotal;
            detalle['impuestos'] = [];
            let impuesto = {};
            impuesto['codigo'] = 2;
            impuesto['codigoPorcentaje'] = (item.iva > 0 ? 2 : 0);
            impuesto['tarifa'] = (item.iva > 0 ? 12 : 0);
            impuesto['baseImponible'] = item.subtotal;
            //impuesto['valor'] = Math.round(item.iva * 100) / 100;
            impuesto['valor'] = this.utils.redondear(item.iva, this.numero_decimales);
            detalle['impuestos'].push(impuesto);
            ventaElectronica['datos']['detalles'].push(detalle);
        });

        ventaElectronica['datos']['infoAdicional'] = [];
        let adicional = {};
        adicional['Email'] = this.correos.toString();// this.cliente.correo;
        adicional['Direccion'] = this.cliente.direccion.replace('/', '-');

        let telefono = "0999999999";
        if (this.cliente.telefono.toString().trim().length > 0) {
            telefono = this.cliente.telefono.toString();
        }
        if (this.cliente.celular.toString().trim().length > 0) {
            telefono = this.cliente.celular.toString();
        }
        adicional['Telefono'] = telefono;

        ventaElectronica['datos']['infoAdicional'].push(adicional);

        return ventaElectronica;
    }

    onSubmit() {
        let preg = "¿Está seguro de confirmar la venta?";
        const initialState = { Pregunta: preg, Respuesta: false };
        this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, { initialState }));

        this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
            if (Respuesta == true) {
                this.setValueCobro();
                this.setValueEntity();

                if (this.Mod_FactElec) {
                    if (this.venta.cliente.es_contribuyente) {
                        if (this.venta.cliente.num_contribuyente.toString().trim().length === 0) {
                            this.msgSweet.showMessage('error-message', "El cliente no consta con número de contribuyente");
                            return false;
                        }
                    }
                    if (this.venta.total >= 200 && this.venta.cliente.id == "1" && this.venta.tipo_comprobante_id == "4") {
                        this.msgSweet.showMessage('error-message', "No puede realizar una venta cuyo monto supere los $200 a Consumidor Final");
                        return false;
                    }
                    this.venta.json_string = this.setVentaElectronica(this.venta);
                }

                this.cliente.correo = this.correos.toString();

                this.loading = true;
                this.ventaService.save(this.venta).subscribe(
                    res => {
                        this.loading = false;

                        if (this.Mod_FactElec) {
                            this.cbtContadorService.actualizarContador();
                        }

                        this.isPrinted = true;
                        this.ventaIdPrinted = res.id;

                        this.onPrint();

                        //this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente - CAMBIO: ' + numeral(this.cambio).format("0,0.00"));
                        let bodega_id = this.venta.bodega_id;
                        this.venta = new Venta();
                        this.venta.bodega_id = bodega_id;
                        //this.venta.tipo_comprobante_id = this.tipos[0].id;
                        //this.cliente = new Cliente();
                        this.amortizacion = new Amortizacion();
                        this.ventasDetalle = [];
                        this.cambio = 0;
                        this.total_pago = 0;

                        this.cheques = [];
                        this.tarjetas = [];
                        this.valorefectivo = 0;
                        this.transferencias = [];



                        this.datosPagos.total_cheque = 0;
                        this.datosPagos.total_tarjeta = 0;
                        this.datosPagos.total_efectivo = 0;
                        this.datosPagos.total_transferencia = 0;
                        

                        this.numero_documento = "";

                        this.getConsumidorFinal().then();
                    },
                    err => {
                        this.loading = false;
                        this.msgSweet.showMessage('error-message', err);
                    }
                );
            }
        });
    }

    onValidDateFecha() {
        return this.validDateFecha = this.vl.validDate(this.fecha_emision.toString());
    }

    onDelete(i) {
        this.ventasDetalle.splice(i, 1);
        this.calcularFactura();
        this.calcularCuotasCredito();
    }

    isValidForm() {
        if (this.is_numero_manual) {
            if (this.numero_documento.trim().length === 0) {
                return false;
            } else {
                if (parseFloat(this.numero_documento.trim()) < 1) {
                    return false;
                }
            }
        }
        if (!this.venta.tipo_comprobante_id) {
            return false;
        }
        if (!this.venta.numero_documento) {
            return false;
        }
        if (!this.vl.validDate(this.fecha_emision.toString())) {
            return false;
        }
        if (this.Mod_Inventario) {
            if (!this.venta.bodega_id) {
                return false;
            }
        }
        if (!this.cliente.dni) {
            return false;
        }
        if (!this.ventasDetalle.length) {
            return false;
        }
        if (!this.venta.tipo) {
            return false;
        }
        if (this.venta.tipo === "CO") {
            if (this.total_pago < this.venta.total) {
                return false;
            }
        }
        if (this.Mod_FactElec) {
            if (this.correos.length === 0) {
                return false;
            }
        }
        return true;
    }

    /*getIVA(){
        return new Promise((resolve, reject) => {
            this.parametroService.getById(1).subscribe(
                res => {
                    this.IVA = parseFloat(res.valor) / 100;
                    this.IVA_PARAM = res.valor;
                    resolve();
                },
                err => {
                    this.IVA = 0;
                    this.IVA_PARAM = 0;
                    reject(err);
                }
            );
        });
    }*/

    getTiposComprobante() {
        return new Promise((resolve, reject) => {

            if (this.Mod_FactElec) {
                this.Identif = "4,2";
            }
            else {
                this.Identif = "1,2";
            }

            this.tipoComprobanteService.getAll("?in[id]=" + this.Identif + "&sort=nombre").subscribe(
                res => {
                    if (res.data.length) {
                        this.tipos = res.data;
                        //this.venta.tipo_comprobante_id = this.tipos[0].id;
                        //this.onChangeComprobante();
                    } else {
                        this.tipos = [];
                    }
                    resolve();
                },
                err => {
                    this.tipos = [];
                    reject(err);
                }
            );
        });
    }

    getBodegas() {
        return new Promise((resolve, reject) => {
            this.bodegaService.getAll("?sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
                res => {
                    if (!res.data.length) {
                        this.bodegas = [];
                    } else {
                        this.bodegas = res.data;
                        this.bodegas_selected.push(this.bodegas[0].id);
                    }
                    resolve();
                },
                err => {
                    this.bodegas = [];
                    reject(err);
                }
            );
        });
    }

    getBodegaBySucursal() {
        return new Promise((resolve, reject) => {
            if (!this.Mod_Inventario) {
                this.venta.bodega_id = "1"; // BODEGA POR DEFECTO / SUCURSAL 1
                resolve();
            } else {
                this.bodegaService.getAll("?sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
                    res => {
                        this.venta.bodega_id = res.data[0].id;
                        resolve();
                    },
                    err => {
                        this.venta.bodega_id = "";
                        reject()
                    }
                );
            }
        });
    }

    /*getParamDocumentoManual(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let documento_manual_id = 9;
            this.parametroService.getById(documento_manual_id).subscribe(
                res => {
                    this.is_numero_manual = (res.valor.toString().trim() === "SI");
                    resolve();
                },
                err => {
                    this.is_numero_manual = false;
                    reject(err);
                }
            );
        });
    }*/

    getDataSucursal() {
        return new Promise((resolve, reject) => {
            this.sucursalService.getById(this.ss.getData('sucursal_id')).subscribe(
                res => {
                    this.sucursal = res;

                    resolve();
                },
                err => {
                    this.sucursal = new Sucursal();
                    reject(err);
                }
            );
        });
    }

    onChangeComprobante() {
        this.isPrinted = false;
        this.ventaIdPrinted = "";
        this.getNumeroComprobante();
    }

    changeValue(event, venta_detalle: VentaDetalle, campo: string) {
        let dscto_valor = venta_detalle.desc_valor;
        let dscto_porcent = venta_detalle.desc_porcent;
        let value = event.target.value;

        venta_detalle[campo] = value;

        if (campo === 'desc_porcent') {
            if (venta_detalle[campo] > 100) {
                venta_detalle[campo] = 100;
            }
        }

        let subtotal = (venta_detalle.cantidad * venta_detalle.precio_unitario) - venta_detalle.desc_valor;
        let porcent_value = subtotal * (venta_detalle.desc_porcent / 100)
        venta_detalle.subtotal = subtotal - porcent_value;

        this.calcularFactura();
        this.calcularCuotasCredito();
    }

    getNumeroComprobante() {
        if (!this.venta.tipo_comprobante_id) {
            this.venta.serie = "";
            this.venta.punto_emision = "";
            this.venta.secuencial = "";
            this.venta.numero_documento = "";
            return;
        }

        this.loading = true;

        this.comprobanteService.getSecuencial(this.venta.tipo_comprobante_id, this.caja.id).subscribe(
            res => {
                this.loading = false;
                if (res.secuencial) {
                    this.venta.serie = this.sucursal.establecimiento;
                    this.venta.punto_emision = this.caja.punto_emision;
                    this.venta.secuencial = res.secuencial;

                    this.venta.numero_documento = this.venta.serie + "-" + this.venta.punto_emision + "-" + this.venta.secuencial;
                } else {
                    this.venta.serie = "";
                    this.venta.punto_emision = "";
                    this.venta.secuencial = "";
                    this.venta.numero_documento = "";
                }
                this.calcularFactura();
                this.calcularCuotasCredito();
            },
            err => {
                this.loading = false;
                this.venta.serie = "";
                this.venta.punto_emision = "";
                this.venta.secuencial = "";
                this.venta.numero_documento = "";

                this.msgSweet.showMessage('error-message', err);
            }
        );
    }

    onChangeBodega(event, bodega_id) {
        this.bodegas_selected.push(bodega_id);

        if (this.ventasDetalle.length > 0) {
            this.msgSweet.showMessage('delete-confirm-message', "¿Está seguro de cambiar de bodega? El detalle de la compra se perderá").then(
                res => {
                    if (res == "ok") {
                        this.ventasDetalle = [];
                    } else {
                        this.venta.bodega_id = this.bodegas_selected[this.bodegas_selected.length - 2];
                        this.bodegas_selected.push(this.venta.bodega_id);
                    }
                },
                err => {
                    this.venta.bodega_id = this.bodegas_selected[this.bodegas_selected.length - 2];
                    this.bodegas_selected.push(this.venta.bodega_id);
                }
            );
        } else {
            this.ventasDetalle = [];
        }
    }

    calcularFactura() {
        this.venta.subtotal_iva12 = 0;
        this.venta.subtotal_iva0 = 0;
        this.venta.subt_desct_iva12 = 0;
        this.venta.subt_desct_iva0 = 0;
        this.venta.subt_desct_iva0 = 0;
        this.venta.subt_desct_iva12 = 0;
        this.venta.iva = 0;
        this.venta.total = 0;
        let tipo_comprobante_id = parseInt(this.venta.tipo_comprobante_id.toString());

        this.ventasDetalle.forEach(obj => {
            if ((tipo_comprobante_id === 1 && obj.graba_iva) || tipo_comprobante_id === 4 && obj.graba_iva) {
                this.venta.subtotal_iva12 += obj.subtotal;
            } else {
                this.venta.subtotal_iva0 += obj.subtotal;
            }
        });
        let desc_porcent = (this.venta.desct_porcent / 100);
        //desc_porcent = Math.round(desc_porcent * 100) / 100;
        desc_porcent = this.utils.redondear(desc_porcent, this.numero_decimales);
        this.venta.desct_valor = (this.venta.subtotal_iva0 + this.venta.subtotal_iva12) * desc_porcent;
        this.venta.subt_desct_iva0 = this.venta.subtotal_iva0 - (desc_porcent * this.venta.subtotal_iva0);
        this.venta.subt_desct_iva12 = this.venta.subtotal_iva12 - (desc_porcent * this.venta.subtotal_iva12);

        if (tipo_comprobante_id === 1 || tipo_comprobante_id === 4) {
            //this.venta.iva = Math.round((this.venta.subt_desct_iva12 * this.IVA) * 100) / 100;
            this.venta.iva = this.utils.redondear((this.venta.subt_desct_iva12 * this.IVA), this.numero_decimales);

        } else {
            //this.venta.iva = Math.round(this.venta.subt_desct_iva12 * 100) / 100;
            this.venta.iva = this.utils.redondear(this.venta.subt_desct_iva12, this.numero_decimales);
        }

        this.venta.total = this.venta.subt_desct_iva12 + this.venta.subt_desct_iva0 + this.venta.iva;

        //this.venta.total = Math.round(this.venta.total * 100) / 100;
        this.venta.total = this.utils.redondear(this.venta.total, this.numero_decimales);

        //Recalcular cambio
        this.total_pago = 0;
        //TODO: this.fpSelected.forEach(e => this.total_pago += parseFloat(e.value.toString()));
        this.cambio = (this.total_pago > this.venta.total ? (this.total_pago - this.venta.total) : 0);
        //this.cambio = Math.round(this.cambio * 100) / 100;
        this.cambio = this.utils.redondear(this.cambio, this.numero_decimales);
    }

    onSearchCliente(event) {
        if (event.keyCode === 13) {
            if (this.cliente.dni.toString().trim().length == 0) {
                this.cliente = new Cliente();
                return;
            } else {
                //this.loading = true;
                this.clienteService.getByDni(this.cliente.dni).subscribe(
                    res => {
                        this.loading = false;
                        if (res.length > 0) {
                            this.cliente = res[0];
                        } else {
                            this.cliente = new Cliente();
                            this.openDialogCliente();
                        }
                    },
                    err => {
                        this.loading = false;
                        this.openDialogCliente();
                    }
                );
            }
        }
    }

    openDialogCliente() {
        const initialState = { qs: "&embed=tipoidentificacion" };
        this.bsModalRef = this.modalService.show(ClienteModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

        this.bsModalRef.content.sendCliente.take(1).subscribe((cliente) => {
            this.cliente = cliente;
            //this.correos = this.cliente.correo.split(',');

            if (this.cliente.correo.trim().length) {
                this.correos = this.cliente.correo.split(',');
            }
        });
    }

    onSearchProducto() {
        if (!this.venta.tipo_comprobante_id) {
            this.msgSweet.showMessage('error-message', "Seleccione el tipo de comprobante");
            return;
        }

        if (!this.venta.bodega_id) {
            this.msgSweet.showMessage('error-message', "Seleccione la bodega");
            return;
        }

        const initialState = { bodega_id: this.venta.bodega_id, numero_decimales: this.numero_decimales };
        this.bsModalRef = this.modalService.show(ProductoPrecioModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

        this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {
            this.sendObjectProducto(value);
        });
    }

    onSearchServicio() {
        if (!this.venta.tipo_comprobante_id) {
            this.msgSweet.showMessage('error-message', "Seleccione el tipo de comprobante");
            return;
        }

        const initialState = { numero_decimales: this.numero_decimales };
        this.bsModalRef = this.modalService.show(ServicioModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

        this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {
            this.sendObjectProducto(value);
        });
    }

    onSearchProforma() {
        if (!this.venta.tipo_comprobante_id) {
            this.msgSweet.showMessage('error-message', "Seleccione el tipo de comprobante");
            return;
        }

        const initialState = { numero_decimales: this.numero_decimales };
        this.bsModalRef = this.modalService.show(ProformaModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

        this.bsModalRef.content.sendProforma.take(1).subscribe((value) => {
            this.getProforma(value.id);
        });
    }

    getProforma($id) {
        let arrayPromise = [];
        return new Promise((resolve, reject) => {
            this.proformaService.getById($id, "?embed=detalle,cliente?embed=tipoidentificacion").subscribe(
                res => {
                    this.proforma = res.data;
                    this.cliente = this.proforma.cliente;
                    this.venta.bodega_id = this.proforma.bodega_id;

                    this.ventasDetalle = [];
                    this.proforma.detalle.forEach(item => {
                        let producto: any = {};

                        arrayPromise.push(new Promise((resolve, reject) => {
                            this.productoService.getWithPrice(this.venta.bodega_id, '?page=1&per_page=10&producto_id=' + item.producto_id).subscribe(
                                res => {
                                    if (res.data.length) {
                                        let data1 = res.data[0];
                                        producto['unidad'] = data1.unidad;
                                        producto['codigo'] = data1.codigo;
                                        producto['cantidad_stock'] = data1.cantidad_stock;
                                        // producto['es_servicio'] = data1.es_servicio;
                                        producto['tipo_producto_id'] = data1.tipo_producto_id;
                                        producto['descripcion'] = data1.descripcion;
                                        producto['nombre'] = data1.nombre;
                                        producto['id'] = data1.id;
                                        producto['graba_iva'] = data1.graba_iva;
                                        producto['precio'] = data1.precio;
                                        producto['cantidad'] = item.cantidad;

                                        this.sendObjectProducto(producto)
                                    }
                                    else {
                                        this.msgSweet.showMessage('error-message', "El producto no tiene stock suficiente");

                                    }

                                    resolve();
                                },
                                err => {
                                    reject(err);
                                }
                            );
                        }));
                    });

                    Promise.all(arrayPromise).then(
                        res => resolve(),
                        err => reject(err)
                    );
                },
                err => {
                    this.proforma = new Proforma;
                    reject(err);
                }
            );
        });
    }

    sendObjectProducto(producto: any) {
        //let temp = this.ventasDetalle.find(x => x.producto_id == producto.id);

        //if (!temp) {
        let venta_detalle = new VentaDetalle();
        venta_detalle.cantidad_stock = producto.cantidad_stock;
        venta_detalle.cantidad = (producto.cantidad ? producto.cantidad : 1);
        // venta_detalle.es_servicio = producto.es_servicio;
        venta_detalle.tipo_producto_id = producto.tipo_producto_id;
        venta_detalle.descripcion = producto.descripcion;
        venta_detalle.producto = producto.nombre;
        venta_detalle.codigo = producto.codigo;
        venta_detalle.imagen = producto.imagen;
        venta_detalle.unidad = producto.unidad;
        venta_detalle.producto_id = producto.id;
        venta_detalle.graba_iva = producto.graba_iva;
        venta_detalle.precio_unitario = parseFloat(producto.precio);
        venta_detalle.subtotal = venta_detalle.cantidad * venta_detalle.precio_unitario;

        if (parseInt(this.venta.tipo_comprobante_id.toString()) === 1 || parseInt(this.venta.tipo_comprobante_id.toString()) === 4) {
            if (producto.graba_iva === 0) {
                venta_detalle.iva = 0;
                venta_detalle.porct_iva = 0;
            } else {
                venta_detalle.iva = venta_detalle.subtotal * this.IVA;
                venta_detalle.porct_iva = this.IVA_PARAM;
            }
        } else {
            venta_detalle.iva = 0;
            venta_detalle.porct_iva = 0;
        }

        venta_detalle.total = venta_detalle.subtotal + venta_detalle.iva;
        venta_detalle.usuario_id = this.ss.getData('usuario_id');
        venta_detalle.empresa_id = this.ss.getData('empresa_id');
        venta_detalle.sucursal_id = this.ss.getData('sucursal_id');

        this.ventasDetalle.push(venta_detalle);
        this.calcularFactura();
        this.calcularCuotasCredito();
        //}

    }

    onCaja($id) {
        return new Promise((resolve, reject) => {
            this.cajaService.getById($id).subscribe(
                res => {
                    this.caja = res;
                    resolve();
                },
                err => {
                    reject(err);
                }
            );
        });
    }

    calcularTotal(total) {
        this.total_pago = total;

        //CALCULAR CAMBIO
        let saldo = this.venta.total - this.venta.abonado;

        if (this.venta.retencion) {
            saldo = saldo - this.venta.retencion.total;
        }

        this.cambio = (this.total_pago > saldo ? (this.total_pago - saldo) : 0);
        //this.cambio = Math.round( this.cambio * 100) / 100;
        this.cambio = this.utils.redondear(this.cambio, this.numero_decimales);
        this.calcularCuotasCredito();
    }

    verificationValue(event, venta_detalle: VentaDetalle, campo: string) {
        if (event.target.value.trim().length === 0) {
            if (campo === 'cantidad') {
                venta_detalle[campo] = 1;
            } else {
                venta_detalle[campo] = 0;
            }
        }
    }

    onChangeEfectivo(total) {
        this.calcularCuotasCredito();
        this.valorefectivo = total;
    }

    openModalDetalle(template: TemplateRef<any>, venta_detalle) {
        this.detalle = venta_detalle.detalle;
        this.venta_detalle = venta_detalle;
        this.bsModalRef = this.modalService.show(template);
    }

    saveDetalle() {
        this.venta_detalle.detalle = this.detalle.toString().trim();
        this.detalle = "";
        this.bsModalRef.hide();
    }

    onAperturaCaja() {
        return new Promise((resolve, reject) => {
            let qs = "?usuario_id=" + this.ss.getData('usuario_id');
            this.asignacionService.getAsignacion(qs).subscribe(
                res => {
                    if (res['tipo'] == 'A') {
                        this.asignacion_id = res['id'];
                        this.onCaja(res['caja_id']).then(
                            res => resolve(),
                            err => reject(err),
                        );
                    } else {
                        const initialState = { caja_id: 0 };
                        this.bsModalRef = this.modalService.show(AperturaCajaModalComponent, Object.assign({ backdrop: 'static' }, { initialState }));

                        this.bsModalRef.content.action.take(1).subscribe((caja_id) => {
                            //this.onCaja(caja_id);

                            let qs = "?usuario_id=" + this.ss.getData('usuario_id');
                            this.asignacionService.getAsignacion(qs).subscribe(
                                res => {
                                    if (res['tipo'] == 'A') {
                                        this.asignacion_id = res['id'];
                                        this.onCaja(res['caja_id']).then(
                                            res => resolve(),
                                            err => reject(err),
                                        );
                                    } else {
                                        resolve();
                                    }
                                },
                                err => {
                                    reject(err);
                                }
                            );
                        });

                        resolve();
                    }
                },
                err => {
                    reject(err);
                }
            );
        });
    }

    onCierreCaja() {
        const initialState = { asignacion_id: this.asignacion_id, Respuesta: false };
        this.bsModalRef = this.modalService.show(CierreCajaModalComponent, Object.assign({ backdrop: 'static' }, { initialState }));

        this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
            if (Respuesta == true) {
                this.caja = new Caja();
                this.onAperturaCaja();
            }
        });
    }

    openModalPrecios(ventaDetalle: VentaDetalle) {
        //const initialState = { detalle: ventaDetalle};
        const initialState = { producto_id: ventaDetalle.producto_id, descripcion: ventaDetalle.producto };
        this.bsModalRef = this.modalService.show(PreciosModalComponent, Object.assign({ backdrop: 'static' }, { class: 'modal-sm', initialState }));

        this.bsModalRef.content.sendPrecio.take(1).subscribe((precio) => {
            this.PreciosAdd = precio;

            ventaDetalle.precio_unitario = parseFloat(this.PreciosAdd.valor.toString());
            ventaDetalle.subtotal = ventaDetalle.cantidad * ventaDetalle.precio_unitario;
            this.calcularFactura();
            this.calcularCuotasCredito();

        });
    }

    onBarCode() {
        //this.bsModalRef = this.modalService.show(template);
        if (!this.venta.tipo_comprobante_id) {
            this.msgSweet.showMessage('error-message', "Seleccione el tipo de comprobante");
            return;
        }

        if (!this.venta.bodega_id) {
            this.msgSweet.showMessage('error-message', "Seleccione la bodega");
            return;
        }
        const initialState = { bodega_id: this.venta.bodega_id };
        this.bsModalRef = this.modalService.show(LectorBarraModalComponent, Object.assign({}, { class: '', initialState }));
        this.bsModalRef.content.sendProducto.subscribe((value) => {
            let producto: Producto = value;
            this.sendObjectProducto(producto);
        });
        this.product_barcode = null;
        this.notfound_barcode = null;
    }

    onImage(producto) {
        this.ruta_imagen = this.uploadfile_api + "/image/" + (producto.imagen != "" ? producto.imagen : "nofoto.png") + "/300?tk=" + this.ss.getData('api-token') + "&dbname=" + this.ss.getData('dbname');

        const initialState = { title: producto.producto, ruta_image: this.ruta_imagen };
        this.bsModalRef = this.modalService.show(ImageModalComponent, Object.assign({}, { class: 'modal-sm', initialState }));
    }

    onPrint() {
        if (this.Mod_FactElec) {
            if (this.venta.tipo_comprobante_id == "4") { // FACTURA ELECTRONICA
                this.printCbtFactElect();
            } else { // NOTA DE VENTA
                this.printCbtNotaVenta();
            }
        } else {
            if (this.venta.tipo_comprobante_id == "1") { //FACTURA FISICA
                this.printFacturaFisica();
            } else { //NOTA DE VENTA
                this.printCbtNotaVenta();
            }
        }
    }

    printCbtFactElect() {
        const initialState = { route: "cbt/factelect/" + this.ventaIdPrinted, qs: "?dbname=" + this.ss.getData('dbname') + "&factid=" + this.ss.getData('fact_id') + "&facttk=" + this.ss.getData('fact-api-token') };
        this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, { class: '', initialState }));
    }

    printCbtNotaVenta() {
        const initialState = { route: "cbt/notaventa/" + this.ventaIdPrinted, qs: "?dbname=" + this.ss.getData('dbname') + "&factid=" + this.ss.getData('fact_id') + "&facttk=" + this.ss.getData('fact-api-token') };
        this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, { class: '', initialState }));
    }

    printFacturaFisica() {
        //this.printCbtFactElect();
        //CAMBIADO POR MARKET
        this.printCbtNotaVenta();
    }

    openModalCredito(template: TemplateRef<any>) {
        //this.calcularCuotasCredito();
        this.bsModalRef = this.modalService.show(template);
        this.valorefectivo = 0;
		this.cheques = [];
        this.tarjetas = [];
        this.transferencias = [];
        this.total_pago= 0;
        this.cambio = 0;
    }

    addCuota() {
        //let cuota = new Cuota();
        let item = new AmortizacionDetalle();
        this.amortizacion.detalle.push(item);
        this.valorefectivo = 0;
        this.cheques = [];
        this.tarjetas = [];
        this.transferencias = [];

        this.calcularCuotasCredito();

    }

    calcularCuotasCredito() {
        let saldo_credito = parseFloat(this.venta.total.toString()) - parseFloat(this.total_pago.toString());
        //let valor_cuota = Math.round((saldo_credito / this.amortizacion.detalle.length) * 100) / 100;
        let valor_cuota = this.utils.redondear((saldo_credito / this.amortizacion.detalle.length), this.calculo_decimales);
        let acumulado = 0;
        let now = moment();
        let fecha = moment(now.format(), moment.ISO_8601).format();

        this.amortizacion.detalle.forEach((item, i) => {
            if ((i + 1) === this.amortizacion.detalle.length) {
                item.cuota = saldo_credito - acumulado;
                //item.cuota = Math.round(item.cuota * 100) / 100;
                item.cuota = this.utils.redondear(item.cuota, this.calculo_decimales);

                let now = moment();
                let fecha = moment(now.format(), moment.ISO_8601).add((i + 1), 'month').format();
                item.fecha_vencimiento = fecha;
            } else {
                acumulado += valor_cuota;
                item.cuota = valor_cuota;

                let now = moment();
                let fecha = moment(now.format(), moment.ISO_8601).add((i + 1), 'month').format();
                item.fecha_vencimiento = fecha;
            }
        });
    }

    removeCuota(i) {
        //this.cuotas_credito.splice(i,1);
        this.amortizacion.detalle.splice(i, 1);
        this.calcularCuotasCredito();
    }

    saldoCuotas() {
        return parseFloat(this.venta.total.toString()) - parseFloat(this.total_pago.toString());
    }

    getTotalCuotasCredito() {
        let total = 0;

        this.amortizacion.detalle.forEach(item => {
            total += item.cuota.toString().length === 0 ? 0 : (parseFloat(item.cuota.toString()));
        });

        total = this.utils.redondear(total, this.calculo_decimales);

        return total;
    }

    isValidFormCuotas() {
        //let totalCuotas = this.numberFormat.transform(this.getTotalCuotasCredito());
        //let ventaTotal = this.numberFormat.transform(this.venta.total);

        let totalCuotas = this.getTotalCuotasCredito();
        let ventaTotal = this.venta.total;
        let total_abonado = this.total_pago;

        if ((totalCuotas + total_abonado) != ventaTotal) {
            return false;
        }
        return true;
    }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/punto-venta-add/punto-venta-add.component.ts